import type { FC, ReactNode } from 'react'
import type Lenis from 'lenis'

import { useEffect } from 'react'
import { engine } from '@/lib/motion/engine'
import { getAppState, subscribeAppState } from '@/lib/app-store'

const SmoothScroll: FC = (): ReactNode => {
    useEffect(() => {
        let disposed = false
        let lenis: Lenis | null = null

        const root = document.documentElement

        if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'manual'

        window.scrollTo(0, 0)
        engine.start()

        const syncLock = (): void => {
            const { loaded, menuOpen, requestOpen } = getAppState()
            const locked = !loaded || menuOpen || requestOpen

            root.classList.toggle('is-locked', locked)

            if (!lenis) return

            if (locked) lenis.stop()
            else lenis.start()
        }

        syncLock()

        import('lenis')
            .then(({ default: LenisClass }) => {
                if (disposed) return

                lenis = new LenisClass({
                    lerp: 0.07,
                    wheelMultiplier: 0.85,
                    touchMultiplier: 1.1,
                    smoothWheel: true,
                    syncTouch: false,
                    autoRaf: false,
                    anchors: false
                })

                engine.setLenis(lenis)
                syncLock()
            })
            .catch(() => undefined)

        const unsubscribe = subscribeAppState(syncLock)

        return () => {
            disposed = true
            unsubscribe()
            engine.setLenis(null)
            lenis?.destroy()
            root.classList.remove('is-locked')
            engine.stop()
        }
    }, [])

    return null
}

export default SmoothScroll
